export class RandomTextReveal {
  private element!: HTMLElement;
  private originalText!: string;
  private revealSpeed!: number; // ms per character

  constructor(selector: string, delay: number = 0, speed: number = 30) {
    const element = document.querySelector(selector) as HTMLElement;
    if (!element) {
      console.warn(`Element not found: ${selector}`);
      return;
    }

    this.element = element;
    this.originalText = element.textContent || "";
    this.revealSpeed = speed;

    // Hide text initially
    this.element.style.opacity = "0";

    // Start animation after delay
    setTimeout(() => this.animate(), delay);
  }

  private animate() {
    const text = this.originalText;
    const words = text.split(/(\s+)/); // Split by whitespace but keep the whitespace

    let charIndex = 0;

    // Create word spans, each containing character spans
    this.element.innerHTML = words
      .map((word) => {
        if (word.match(/^\s+$/)) {
          // Whitespace - keep as regular text for proper word wrapping
          charIndex += word.length;
          return word;
        }

        // Create character spans for each word, wrapped in a word container
        const wordChars = word
          .split("")
          .map((char) => {
            return `<span class="reveal-char" data-index="${charIndex++}" style="opacity: 0;">${char}</span>`;
          })
          .join("");

        return `<span class="reveal-word" style="display: inline-block; white-space: nowrap;">${wordChars}</span>`;
      })
      .join("");

    this.element.style.opacity = "1";

    // Get all character spans
    const charSpans = this.element.querySelectorAll(
      ".reveal-char"
    ) as NodeListOf<HTMLElement>;

    // Create array of indices and shuffle them
    const indices = Array.from({ length: charSpans.length }, (_, i) => i);
    this.shuffleArray(indices);

    // Reveal characters in random order
    indices.forEach((index, step) => {
      setTimeout(() => {
        charSpans[index].style.opacity = "1";
        charSpans[index].style.transition = "opacity 0.1s ease";

        // Add glitch flash effect randomly
        if (Math.random() > 0.7) {
          charSpans[index].style.color = "var(--hud-cyan)";
          charSpans[index].style.textShadow = "0 0 10px var(--hud-cyan)";
          setTimeout(() => {
            charSpans[index].style.color = "";
            charSpans[index].style.textShadow = "";
          }, 50);
        }
      }, step * this.revealSpeed);
    });
  }

  private shuffleArray(array: number[]) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
  }
}
